import { render } from "./BottomListAvatarView.vue?vue&type=template&id=222b1cdf&scoped=true"
import script from "./BottomListAvatarView.vue?vue&type=script&lang=js"
export * from "./BottomListAvatarView.vue?vue&type=script&lang=js"

import "./BottomListAvatarView.vue?vue&type=style&index=0&id=222b1cdf&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222b1cdf"]])

export default __exports__